import { ChecklistRole } from "./checklistAppState";
import {
  SerializedChecklist,
  SerializedChecklistDocumentElement,
  SerializedPageBreak,
} from "./checklistSerialized";
import { SimulatorPlatform } from "./simulators";

export interface AddonBase {
  id: string;
  title: string;
  platforms: SimulatorPlatform[];
  image: string | null;
}

export type AddonTemplate = BlankTemplate | AircraftAddonTemplate | SoftwareAddonTemplate;

export interface BlankTemplate extends AddonBase {
  type: "blank";
  content: SerializedChecklistDocumentElement[];
}

export interface AircraftAddonTemplate extends AddonBase {
  type: "aircraft";
  content: AddonTemplateChecklistDocumentElement[];
  image: string;
  infoMarketingBlurb?: () => JSX.Element;
}

export type AddonTemplateChecklistDocumentElement = AddonTemplateChecklist | SerializedPageBreak;

export interface SoftwareAddonTemplate extends AddonBase {
  type: "software";
  content: AddonTemplateChecklist[];
}

export type AddonTemplateChecklist = SerializedChecklist & {
  roles: ChecklistRole[];
};

export function isBlankTemplate(addonTemplate: AddonTemplate): addonTemplate is BlankTemplate {
  return addonTemplate.type === "blank";
}

export function isAircraftAddonTemplate(
  addonTemplate: AddonTemplate
): addonTemplate is AircraftAddonTemplate {
  return addonTemplate.type === "aircraft";
}

export function isSoftwareAddonTemplate(
  addonTemplate: AddonTemplate
): addonTemplate is SoftwareAddonTemplate {
  return addonTemplate.type === "software";
}

export function isAddonTemplateChecklist(
  element: AddonTemplateChecklistDocumentElement
): element is AddonTemplateChecklist {
  return (
    (element as AddonTemplateChecklist).title !== undefined &&
    (element as AddonTemplateChecklist).content !== undefined
  );
}
